<template>
    <div class="fill-height">
        <Header></Header>
        <slot />
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from "@/components/Header";
    import Footer from "@/components/Footer";
    export default {
        name: "LayoutBasic",
        components: {
            Header,
            Footer,
        },
        mounted() {
            if (window.fcWidget) {
                window.fcWidget.hide();
            }
        },
    };
</script>
